import { Typography } from "@mui/material";
import "../css/card.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const ProductCard = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    axios
      .post(
        "http://api.meddaily.in/category_product",
        {
          category_id: categoryId,
        },
        { headers: { token: sessionStorage.getItem("token") } }
      )
      .then((res) => {
        setCardData(res.data.product);
        // setCardData(res.data.category);
      })
      .catch((error) => console.error("Error fetching banner data:", error));
  }, []);

  // const onProductClick = (id) => {
  //   navigate(`/ordersummary/${id}`);
  // }

  const onProductClick = (id) => {
    navigate(`/details/${id}`);
  };

  return (
    <>
      {cardData.map((item) => (
        <div className="card" key={item._id}>
          <Typography
            variant="h6"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item.name}
            <br />
          </Typography>
          <Typography
            mt={4}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item.subtitle}
          </Typography>

          <Typography mt={3} mb={2} variant="h6">
            Best Price*{" "}
            <span style={{ color: "#30d5c8" }}>₹ {item.price} </span>
          </Typography>

          <button
            className="buy-now-btn"
            onClick={() => onProductClick(item._id)}
          >
            {" "}
            Buy Now
          </button>
        </div>
      ))}
    </>
  );
};
export default ProductCard;
